import { useState, useEffect, Fragment } from 'react'
import { AppNavLink } from './AppNavLink'
import { FormattedMessage } from 'react-intl'
import { useDispatch } from 'react-redux'
import { StoreThunkDispatch } from 'store/state'
import { getStreams } from 'services/content/streams/actions'
import styles from './AppNavigation.pcss'
import { getStorageInfo, getUploads } from 'services/uploads/actions'
import { StreamsNavMenu } from './StreamsNavMenu'
import { LibraryNavMenu } from './LibraryNavMenu'
import { getUserPrompts } from 'services/compose'

export function ContentNav(props: { expanded: boolean }) {
  const [openSubnav, setOpenSubnav] = useState<null | 'streams' | 'library' | 'studio'>(null)
  const [expandedStreamId, setExpandedStreamId] = useState<string | undefined>(undefined)
  const dispatch = useDispatch<StoreThunkDispatch>()

  useEffect(() => {
    setExpandedStreamId(undefined)
  }, [openSubnav])

  useEffect(() => {
    dispatch(getUploads(true)).unwrap()
    dispatch(getStreams(true)).unwrap()
    const aiPromptsSub = dispatch(getUserPrompts()).subscribe()
    dispatch(getStorageInfo())

    return () => {
      aiPromptsSub.unsubscribe()
    }
  }, [dispatch])

  const toggleMLExpanded = () => {
    setOpenSubnav(current => current === 'library' ? null : 'library')
  }

  const toggleMSExpanded = () => {
    setOpenSubnav(current => current === 'streams' ? null : 'streams')
  }

  const toggleStudioExpanded = () => {
    setOpenSubnav(current => current === 'studio' ? null : 'studio')
  }

  const onToggleExpandedStream = (id: string) => {
    setExpandedStreamId(current => current === id ? undefined : id)
  }

  return (
    <nav data-testid="content-nav">
      <h1 className={styles['subnav-title']}>
        <FormattedMessage id="app.nav.title-content" />
      </h1>
      <AppNavLink
        label={<FormattedMessage id="app.nav.home" />}
        to="/content"
        end
        withTooltip={!props.expanded}
      />
      <StreamsNavMenu
        expanded={props.expanded && openSubnav === 'streams'}
        expandedStreamId={expandedStreamId}
        onToggleExpanded={toggleMSExpanded}
        onToggleExpandedStream={onToggleExpandedStream}
      />
      <LibraryNavMenu
        expanded={props.expanded && openSubnav === 'library'}
        onToggleExpanded={toggleMLExpanded}
      />
      <AppNavLink
        label={<FormattedMessage id="app.nav.favorites" />}
        to="/content/favorites"
        withTooltip={!props.expanded}
      />
      <AppNavLink
        label={<FormattedMessage id="app.nav.content-studio" />}
        to="/content/studio/image"
        withTooltip={!props.expanded}
        expanded={openSubnav === 'studio'}
        onToggleExpanded={toggleStudioExpanded}
        items={(
          <Fragment>
            <AppNavLink
              label={<FormattedMessage id="app.nav.content-studio-image" />}
              to="/content/studio/image"
              className={styles['child-link']}
            />
            <AppNavLink
              label={<FormattedMessage id="app.nav.content-studio-video" />}
              to="/content/studio/video"
              className={styles['child-link']}
            />
          </Fragment>
        )}
      />
    </nav>
  )
}

export default ContentNav
